import { RootState } from "store";
import { IGetRoleDetailsResponse } from "types/roles-and-rights.interface";

export const getRoleDetailsSelector = (state: RootState): IGetRoleDetailsResponse | null => state.roleDetails.item?.data;
export const getRoleDetailsUpdateSuccess = (state: RootState): boolean | null => Boolean(state.roleDetails.update?.success);

